// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YIzU","title":"styles_title__1TYbt"};